export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-array/src/threshold/sturges.js
// module id = ../../../../d3-array/src/threshold/sturges.js
// module chunks = 3